import axios from 'axios'

export const challengeService = ({
  getAllChallenges (token) {
    return axios.get('/api/challenges', {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteChallenge (token, challengeId) {
    return axios.delete('/api/challenge/delete?ChallengeId=' + challengeId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createChallenge (token, formDataObj) {
    return axios.post('/api/Challenge/Create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateChallenge (token, formDataObj) {
    return axios.put('api/challenge/update', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getChallengesAsPerTopicId (token, topicId) {
    return axios.get('/api/ChallengesByTopicId?topicId=' + topicId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSubmittedChallengeResponseUsers (token, cohortId, elementChallengeId) {
    return axios.get('/api/UserCohort/SubmittedChallengeResponseUsers?cohortId=' + cohortId + '&elementChallengeId=' + elementChallengeId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  doManualAllocation (token, cohortId, elementChallengeId, bossUserId) {
    return axios.post('/api/UserCohort/DoManualAllocation?cohortId=' + cohortId + '&elementChallengeId=' + elementChallengeId + '&bossUserId=' + bossUserId, null, {headers: {'Authorization': 'Bearer ' + token}})
  },
  copyMasterChallenge (token, challengeId) {
    return axios.post('/api/Challenge/Copy?challengeId=' + challengeId, null, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/challenge-service.js